import { createContext } from "react";

const ThumbsContext = createContext({});

export default ThumbsContext;
